const ROOT = '/property-management'

const propertyTypeManagementPaths = {
  root: ROOT,
  addProperty: `${ROOT}/add-property`,
};

export default propertyTypeManagementPaths;